import { formatMember } from "../hooks/useTeamMembers";

/** Match an activity row to a roster member or backend-hydrated user. */
export function findMemberForActivity(activity, { byId, members }) {
  if (activity?.user && (activity.user.name || activity.user.email)) {
    return activity.user;
  }
  const uid = activity?.userId ? String(activity.userId) : "";
  if (uid && byId?.get(uid)) return byId.get(uid);

  const email = String(activity?.userEmail || "").trim().toLowerCase();
  if (!email || !Array.isArray(members)) return null;
  return (
    members.find(
      (m) =>
        m.email?.toLowerCase() === email ||
        m.stubEmail?.toLowerCase() === email
    ) || null
  );
}

/** Human-readable actor label for activity feeds. */
export function activityDisplayName(activity, member) {
  if (member) {
    if (member.name) return member.name;
    return formatMember(member);
  }
  const email = String(activity?.userEmail || "").trim();
  return email || "Someone";
}
